import { useTranslation } from 'react-i18next';
import { useThemePreference } from '../theme/useThemePreference';
import { Icon } from './Icon';

const prefersDark = () =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia('(prefers-color-scheme: dark)').matches
    : false;

/**
 * #928: a one-tap light/dark switch for a page's header. It sets the same theme mode the account
 * menu's Appearance does (ADR 0012) -- from "System", it switches to the opposite of what the
 * system shows now. Structure drawings stay on white paper either way.
 */
export function ThemeToggleButton({ className }: { readonly className?: string }) {
  const { t } = useTranslation();
  const { mode, setMode } = useThemePreference();
  const dark = mode === 'dark' || (mode === 'system' && prefersDark());
  const label = dark ? t('theme.switchToLight') : t('theme.switchToDark');
  return (
    <button
      type="button"
      className={`theme-toggle-button${className ? ` ${className}` : ''}`}
      aria-label={label}
      title={label}
      onClick={() => setMode(dark ? 'light' : 'dark')}
    >
      <Icon name={dark ? 'lightMode' : 'darkMode'} size="1.2rem" />
    </button>
  );
}
